import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(12),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
        display: 'grid',
        gap: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(0, 0, 2),
    },
    alert: {
        marginTop: theme.spacing(3),
    },
}));

export default useStyles